import React from 'react';
import PropTypes from 'prop-types';

import dataModel from '../../../models/DataModel';
import unreadAnnouncements from '../../../helpers/Announcements/UnreadAnnouncements';

import './AnnouncementBanner.scss';

// TODO: collapse other banners into this

/**
 * <AnnouncementBanner> - child component of <GlobalBanner>
 */
export default class AnnouncementBanner extends React.Component {

  constructor(props) {
    super(props);
    AnnouncementBanner.propTypes = {
      /** Text to display in the banner... assumed to be safe html */
      announcement_text: PropTypes.string,
    };
    this.state = {
      shown: false,
    };

    this.closeBanner = this.closeBanner.bind(this);
    this.checkClick = this.checkClick.bind(this);
  }

  componentDidMount() {
    const { announcementId } = this.props;
    // notify that the announcement was read
    unreadAnnouncements.markRead(announcementId);
    setTimeout(() => {
      this.setState({ shown: true });
    }, 0);
  }

  componentWillUnmount() {
    const { announcementId } = this.props;
    unreadAnnouncements.showNextAnnouncement(announcementId);
  }

  /** HELPERS */
  closeBanner() {
    return new Promise((resolve) => {
      this.setState({ shown: false });
      // wait for animation to actually close banner
      setTimeout(() => {
        resolve();
        // hide the component
        dataModel.hideGlobalBanner(this.props.bannerType, this.props.isCompanyBanner);
      }, 150);
    });
  }

  checkClick(e) {
    if (e && e.target && e.target.localName && e.target.localName == 'a') {
      this.closeBanner(e);
    }
  }

  render() {
    const { announcement_text, className } = this.props;

    return (
      <span className={className+' banner' + (this.state.shown ? '' : ' banner--closing')}>
        <span id="announcement_banner_span" className="banner__text" dangerouslySetInnerHTML={{ __html: announcement_text }} onClick={this.checkClick}/>
        <span className="banner__close" onClick={this.closeBanner}>&times;</span>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/banners/AnnouncementBanner/index.js